export default "__VITE_ASSET__CcGqwfim__"